import { render, staticRenderFns } from "./netPay3dsPayment.vue?vue&type=template&id=65ddf89a&"
import script from "./netPay3dsPayment.vue?vue&type=script&lang=ts&"
export * from "./netPay3dsPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports